var map = {
	"./best.svg": 11620,
	"./dream-pos.svg": 43595,
	"./dreamchat.svg": 25964,
	"./project-01.svg": 60276,
	"./project-02.svg": 48135,
	"./project-03.svg": 8598,
	"./servbook.svg": 62002,
	"./sports.svg": 33632,
	"./truellysel.svg": 19806,
	"./truellysell.svg": 16550
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75905;